import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UltrasonicApiService } from '../services/ultrasonic-api.service';

export const orderExistsGuard: CanActivateFn = (route) => {
  const api = inject(UltrasonicApiService);
  const router = inject(Router);
  const orderNumber = Number(route.paramMap.get('orderNumber'));

  if (!Number.isInteger(orderNumber) || orderNumber <= 0) {
    return router.createUrlTree(['/orders']);
  }

  return api.getOrder({ ordernumber: orderNumber }).pipe(
    map((orders) => (orders.length > 0 ? true : router.createUrlTree(['/orders']))),
    catchError(() => of(router.createUrlTree(['/order-not-found'])))
  );
};
